import StatsProcessDto from "./stats-process-dto";

export default interface DashboardProcessDto extends StatsProcessDto {
    hasMetresDepuisPDF: boolean;
    hasPreparationCoques: boolean;
    hasDestinationsCoques: boolean;
    hasSurfaces: boolean;
    hasMetresCarbone: boolean;
    hasMetresQuantitatifGOE: boolean;
    hasQuantitatifLotMex: boolean;
    hasQuantitatifLotMenuiseries: boolean;
    hasAmenagementsAppartements: boolean;
    hasSurfacesPrecisesSOE: boolean;

    hasCalcul1: boolean;
    hasCalcul2: boolean;
    hasCalcul3: boolean;
}

export type ProcessMapping = {
    is2D?: keyof DashboardProcessDto;
    is3D?: keyof DashboardProcessDto;
};

export const PROCESS_DTO_MAPPING: Record<string, ProcessMapping> = {
    PrepareMurs: {
        is2D: "hasMetresDepuisPDF"
    },
    PrepareHulls: {
        is2D: "hasPreparationCoques"
    },
    HullsDestination: {
        is2D: "hasDestinationsCoques",
        is3D: "hasDestinationsCoques"
    },
    Surfaces: {
        is2D: "hasSurfaces",
        is3D: "hasSurfaces"
    },
    QCarbonMetric: {
        is2D: "hasMetresCarbone",
        is3D: "hasMetresCarbone"
    },
    QGrosOeuvres: {
        is2D: "hasMetresQuantitatifGOE",
        is3D: "hasMetresQuantitatifGOE"
    },
    QMex: {
        is2D: "hasQuantitatifLotMex",
        is3D: "hasQuantitatifLotMex"
    },
    QMenuiserie: {
        is2D: "hasQuantitatifLotMenuiseries",
        is3D: "hasQuantitatifLotMenuiseries"
    },
    ApartmentLayout: {
        is2D: "hasAmenagementsAppartements",
        is3D: "hasAmenagementsAppartements"
    },
    GrosOeuvreAffinées: {
        is2D: "hasSurfacesPrecisesSOE",
        is3D: "hasSurfacesPrecisesSOE"
    }
};
